export default "__VITE_ASSET__38844ab3__"